var map = {
	"./130---StartShield.json": 12223,
	"./131---WarriorShield.json": 72454,
	"./132---Shield.json": 81420,
	"./133---AreaShield.json": 40292,
	"./134---BumpShield.json": 85905,
	"./135---Rampart.json": 81512,
	"./136---DashShield.json": 31672,
	"./137---BloodShield.json": 29333,
	"./138---GreedShield.json": 53087,
	"./139---SpikeShield.json": 96404,
	"./140---ParryShield.json": 58502,
	"./141---HoldShield.json": 14239,
	"./142---ThunderShield.json": 39252,
	"./143---IceShield.json": 43872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33771;